require('./ui/common.js');
require('./ui/swiper_init.js');
require('./ui/ajax-forms.js');
require('./ui/popup.js');

require('./ui/jquery.event.move.js');
require('./ui/jquery.twentytwenty.js');
// Init classes
Popup.init();
